import { useState, useEffect } from 'react';
import { fetchTenantDetail, TenantDetail, Service } from '../api';

export function useTenant(slug: string | undefined) {
  const [tenant, setTenant] = useState<TenantDetail | null>(null);
  const [services, setServices] = useState<Service[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) {
      setLoading(false);
      return;
    }

    setLoading(true);
    fetchTenantDetail(slug)
      .then((data) => {
        setTenant(data);
        setServices(data.services);
      })
      .catch(() => {
        setTenant(null);
        setServices([]);
      })
      .finally(() => setLoading(false));
  }, [slug]);

  return { tenant, services, loading };
}
